import { render, staticRenderFns } from "./MakeUserAdmin.vue?vue&type=template&id=d4715c38&scoped=true"
import script from "./MakeUserAdmin.vue?vue&type=script&lang=js"
export * from "./MakeUserAdmin.vue?vue&type=script&lang=js"
import style0 from "./MakeUserAdmin.vue?vue&type=style&index=0&id=d4715c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4715c38",
  null
  
)

export default component.exports